export const Contact = [
"If you have small ad-hoc task or bigger team project or your dream product idea in mobile development ( React Native / Flutter / Ionic / PhoneGap ), please don't hesitate to keep in touch with us. To discuss about our mobile development expertise and services, please mail us on business@istellar.com or call +1 (817) 606-6969 / +91 6969696969",
]
export const FoundationList = [
"Pure ideas",
"Creative solutions",
"On time client interaction",
"Proven track record",
"Being transparent",
"Reasonable cost", 
]
export const inlineAnchor = [
{
    para1: "Start working with ",
    anchor: "IStellar",
    para2: " that can provide everything you need to take care of your business."
}
]
export const MobDevCardData = [
{
    icon: "startupIcon",
    title: "Startup MVP",
    content: "We support entrepreneurs to create MVP from the very beginning until the first release of the product.",
}, {
    icon: "quickIcon",
    title: "Quick & cost effective",
    content: "We develop cost effective cross platform mobile application in limited time interval.",
    bg: "blue",
}, {
    icon: "reliableSupportIcon",
    title: "Reliable Support",
    content: "Reliable & comprehensive support in the hope of enabling our products to be used with ease by everyone.",
}
]
export const paraUL = [
{
    para1: "Mobile phones has already take over the desktop computer for the internet usage. In this era, mobile phone is no more a need. It has become a necessity and it's hard to imagine life without mobile. Mobile apps is the heart of Mobile phones! Are you looking for Expert Mobile App Developers in India? Looking for one of the best mobile app development companies in India for all your Mobile solutions? We're with you.",
    para2: "IStellar is one of the best mobile app development company in India. With our creative design and customized development skills, we developed mobile phone apps that make a difference. We have very strong mobile application developers and we create mobile apps that inspire our client and their customer as well.",
    ul: [
        {li: "React Native Development",
        path: "/services/react-native-development"},
        {li: "Flutter Development",
        path: "/services/flutter-development"},
        {li: "Ionic Development",
        path: "/services/ionic-development"},
        {li: "PhoneGap Development",
        path: "/services/phonegap-development"},
    ]
}
]
export const cordova = [
    "Our Team have expertise experience in developing Cross Platform Mobile Applications. Cross platform development allows the reuse of the Application resources for multiple platforms like iOS, Android, BlackBerry, Windows Phone etc.",
    "Before developing any web application or mobile App we do a detailed research on the market with the similar kind of products to get better ideas and create unique approach of yours. Our clients have an amazing benefit; they are open to track the developing process on each stage by receiving timely status reports. Interact with our team and stay up to date."
]
export const cordovaImg = [
    "cordavaIcon"
]